export default __webpack_public_path__ + "static/media/heatingaids.a0422c0d.jpg";